export default __webpack_public_path__ + "static/media/surveyFull.7e048aa7.png";